/**
 * Collection of custom `Event` names. It does not really matter what the values are – but they have to be unique!
 * @example
 *   const FvCustomEventNames = {
 *     MyCustomEventName: "foo"
 *   }
 *
 *   // Create Event
 *   const evt = new Event(FvCustomEventNames.MyCustomEventName)
 *
 *   // Listen for Event being fired on `document`
 *   document.addEventListener(FvCustomEventNames.MyCustomEventName, () => {
 *     // do something
 *   })
 *
 *   // Fire Event on `document`
 *   document.dispatchEvent(evt)
 */
export const FvCustomEventNames = {
  /** The component BasisHeader becomes non-visible. The out-animation starts. */
  BasisHeaderOut: 'basisHeaderOut',

  /** The component BasisHeader becomes visible. The in-animation starts. */
  BasisHeaderIn: 'basisHeaderIn',

  /** Opens the header */
  BasisHeaderOpen: 'basisHeaderOpen',

  /** Closes the header */
  BasisHeaderClose: 'basisHeaderClose',

  /** A setting for a cookie has changed */
  CookiesChanged: 'cookiesChanged',

  /** Opens the cookie banner */
  CookieBannerOpen: 'cookieBannerOpen',

  /** Opens the cookie banner settings */
  CookieBannerOpenSettings: 'cookieBannerOpenSettings',

  /** Search bar opens */
  BasisSearchOpen: 'basisSearchOpen',

  /** Search bar closes */
  BasisSearchClose: 'basisSearchClose',

  /** Mobile navigation opens */
  BasisMobileNavigationOpens: 'basisMobileNavigationOpens',

  /** Mobile navigation closes */
  BasisMobileNavigationCloses: 'basisMobileNavigationCloses',

  /** When this event is called, the URL is automatically updated with the current search term */
  SearchFieldUpdateUrl: 'searchFieldUpdateUrl'
};
